/**
 * help/tourState — the one-line seam for "show the welcome tour".
 *
 * The Help Center's "Take the tour again" button and the first-login auto-start
 * are the same action, so both go through here rather than lifting the tour's
 * open state into a provider that every page would have to thread.
 *
 * Uses the same document-CustomEvent pattern SearchTrigger already uses to open
 * the command bar — no shared state, no prop drilling.
 */

export const TOUR_EVENT = 'welcometour:open';

/** Ask the mounted WelcomeTour to open. No-op if it isn't mounted. */
export function startTour(): void {
  document.dispatchEvent(new CustomEvent(TOUR_EVENT));
}
